export var makeVerticalVisualCue = (theme, offset) => ({
  border: "2px solid ".concat(theme.color.background.container),
  borderRadius: theme.borderRadius1,
  boxSizing: 'content-box',
  content: '" "',
  height: '12px',
  left: "".concat(-offset, "px"),
  position: 'absolute',
  transition: 'background-color 100ms linear, color 100ms linear',
  width: '2px'
});
export var makeHorizontalVisualCue = (theme, offset) => ({
  border: "2px solid ".concat(theme.color.background.container),
  borderRadius: theme.borderRadius1,
  bottom: "".concat(-offset, "px"),
  boxSizing: 'content-box',
  content: '" "',
  height: '2px',
  position: 'absolute',
  transition: 'background-color 100ms linear, color 100ms linear',
  width: '16px'
});